import { createBrowserRouter } from "react-router-dom";
import Home from "../../Pages/Home/Home/Home";
import Main from "../../Layouts/Main";
import Login from "../../Pages/Login/Login";
import Appointments from "../../Pages/Appointments/Appointments/Appointments";
import SignUp from "../../Pages/SignUp/SignUp";
import Dashboard from "../../Pages/Dashboard/Dashborad/Dashboard";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import Contact from "../../Pages/Home/Contact/Contact";

export const router= createBrowserRouter([
    {
        path:"/",
        element:<Main></Main>,
        children:[
            {
                path:'/',
                element:<Home></Home>
            },
            {
                path:'/login',
                element:<Login></Login>
            },
            {
                path:'/signup',
                element:<SignUp></SignUp>
            },
            {
                path:'/appointment',
                element:<Appointments></Appointments>
            },
            {
                path:'/Contact',
                element:<Contact></Contact>
            }
        ]
    },
    {
        path:'/dashboard',
        element:<PrivateRoute><Dashboard></Dashboard></PrivateRoute>
    }
])

export default router;